export const howItWorks = {
  title: 'How it works',
  subtitle: '',
  items: [
    {
      id: 1,
      image: {
        path: 'homepage11-2022/how-it-works/how-it-works-step-1.png',
        width: 1000,
      },
      title: 'Choose your recipes',
      description:
        'Load your box with up to 5 tasty recipes a week (or as often as you like)',
    },
    {
      id: 2,
      image: {
        path: 'homepage11-2022/how-it-works/how-it-works-step-2.png',
        width: 1000,
      },
      title: 'Schedule a delivery',
      description:
        "We'll get your pre-portioned, ethically sourced ingredients ready",
    },
    {
      id: 3,
      image: {
        path: 'homepage11-2022/how-it-works/how-it-works-step-3.png',
        width: 1000,
      },
      title: 'Enjoy feel-good food',
      description:
        'Easy to follow recipes on the table in as little as 15 mins',
    },
  ],
}
